import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('modal-dialog', () => import(/* webpackMode: "lazy" */'./modal-dialog'));
